export class NztcsSpeciesSearchCriteria {
  nameCriteria: string;
  speciesType: string;

  pageNumber = 1;
  pageSize = 25;

  constructor() {}
}
